export { default } from './Joc';
